















































































































































































































































































































































































































import NoticeMain from "@/components/NoticeMain.vue";
import Vue from "vue";
import ApiService from "../services/ApiService";
import SingleNotice from "@/modals/SingleNotice.vue";
import HomeLogic from "./logic/home";
export default Vue.extend({
  data() {
    return {
      popupAudience: "",
      category: "",
      notices: [],
      schools: [],
      groups: [],
      schoolSelection: null,
      currentFilterLabel: "all",
      showNextPage: false,
      params: { page: 0 },
      loading: true,
      showNewGroup: false,
      editingForm: false,
      group: {},
      audienceData: null,
      stats: {
        eco: 0,
        general: 0,
        pta: 0,
        travel: 0,
        polls: 0,
      },
      lastRefreshed: 0,
    };
  },
  components: {
    NoticeMain,
  },
  props: ["hideSide"],
  methods: {
    showPost(noticeId) {
      // this.$globalLoading = this.$loading.show();
      this.$store.dispatch("loading", true);
      let notice, comments;
      ApiService.generalApi
        .getSingleMessage(noticeId)
        .then((response) => {
          // this.$store.dispatch("loading", false);
          const filtered = HomeLogic.singleNotice(response);
          notice = filtered.notice;
          comments = filtered.comments;
          this.$modal.show(
            SingleNotice,
            {
              noticeId,
              notice,
              comments,
            },
            {
              draggable: false,
              transition: "fade",
              scrollable: true,
              height: "auto",
              adaptive: false,
              pivotY: 0,
              reset: true,
              classes: "postModal v--modal-box v--modal",
            }
          );
        })
        .catch(() => {
          alert("error");
        });
    },
    getNoticeAudience(noticeId) {
      this.popupAudience = "";
      this.audienceData = null;
      ApiService.generalApi
        .getNoticeAudience(noticeId)
        .then((resp) => {
          this.audienceData = resp.data;
          // this.popupAudience = this.formatedAudience(resp.data);
        })
        .catch(() => alert("Error occured"));
    },
    changeCategory(cat) {
      this.category = cat;
    },
    changeSchool(schoolId) {
      this.params.page = 0;
      this.loadNotices(schoolId);
    },
    changeFilter(value) {
      this.$modal.hide("filter");
      this.currentFilterLabel = value;
      this.params.filter = value;
      this.params.page = 0;
      this.loadNotices();
    },
    nextPage() {
      this.params.page = this.params.page + 1;
      this.loadNotices();
    },
    loadNotices(schoolId) {
      this.loading = true;
      if (schoolId) {
        this.params.school_id;
      }
      if (this.params.page === 0) {
        this.lastRefreshed = Math.round(new Date().getTime() / 1000) - 20;
      }
      this.notices = [];
      ApiService.sadminApi
        .getNotices(this.schoolSelection, this.params)
        .then((resp) => {
          const data = resp.data.posts;
          data.forEach((element) => {
            element.extras =
              element.extras != "" ? JSON.parse(element.extras) : [];
            element.years = element.years_label;
            if (resp.data.bucket_url) {
              element.bucket_url = resp.data.bucket_url + "/";
            }
            if (element.images) {
              const imagesAndPdfs = element.images.split(",");
              const images = [];
              const pdfs = [];
              for (let y = 0; y < imagesAndPdfs.length; y++) {
                if (imagesAndPdfs[y].indexOf("pdf") !== -1) {
                  pdfs.push(imagesAndPdfs[y]);
                } else {
                  images.push(imagesAndPdfs[y]);
                }
              }

              element.images = images;
              if (pdfs.length > 0) {
                element.pdfs = pdfs;
              }
            }
          });
          this.loading = false;
          this.stats = resp.data.count;
          if (this.params.page > 0) {
            this.notices = this.notices.concat(data);
            this.$forceUpdate();
          } else {
            this.notices = data;
          }
          if (data.length === 20) {
            this.showNextPage = true;
          } else {
            this.showNextPage = false;
          }
        });
    },
    noticeEvent(options) {
      if (options.action === "showNotice") {
        this.showPost(options.id);
      } else if (options.action === "showChat") {
        this.showConversationModal(options.id);
      } else if (options.action === "hideNotice") {
        let currentIndex;
        for (let i = 0; i < this.notices.length; ++i) {
          if (this.notices[i].id == options.id) {
            currentIndex = i;
            break;
          }
        }
        this.notices.splice(currentIndex, 1);
      }
    },
    showFilterModal() {
      this.$modal.show("filter");
    },
    showForm() {
      this.showNewGroup = true;
    },
    editGroup(obj) {
      this.editingForm = true;
      this.group = obj;
    },
    showGroupsModal() {
      this.$modal.show("groups");
    },
    getGroups() {
      // this.loading = true;
      ApiService.generalApi.getSchoolGroups().then((resp) => {
        this.groups = resp.data;
        // this.loading = false;
      });
    },
    saveGroup() {
      if (!this.group.description) {
        this.$notify.error({
          title: "Error",
          message: "Description is required",
        });
        return;
      }
      if (!this.group.name) {
        this.$notify.error({
          title: "Error",
          message: "Name is required",
        });
        return;
      }
      this.loading = true;
      ApiService.generalApi.saveGroup(this.group).then((resp) => {
        this.getGroups();
        this.showNewGroup = false;
        this.editingForm = false;
        this.group = {};
        this.loading = false;
      });
    },
    deleteGroup(id) {
      this.loading = true;
      ApiService.generalApi.deleteGroup({ id }).then((resp) => {
        this.getGroups();
        this.loading = false;
      });
    },
    deleteNotice(id) {
      this.$confirm(
        "Remove this post from the School Notice Board?",
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      ).then(() => {
        this.$message({
          type: "success",
          message: "Delete completed",
        });
        ApiService.generalApi.deleteNotice(id);
        this.noticeEvent({ action: "hideNotice", id: id });
      });
    },
    onRefresh() {
      this.params.page = 0;
      this.loadNotices();
    },
    formatedAudience(data){
      let returnHtml = '<div>';
      returnHtml += 'Schools: ' + data.schools + '<br />';
      returnHtml += 'Years: ' + data.years + '<br />';
      if(data.groups){
        returnHtml += 'Groups: ' + data.years + '<br />';
      }
      returnHtml += '</div>';
      return returnHtml ;
    }
  },
  computed: {
    accType() {
      return this.$store.state.accType;
    },
    userId: function () {
      return parseInt(this.$store.state.user.id);
    },
  },
  mounted() {
    this.loadNotices();
    this.getGroups();
    ApiService.generalApi.getOrgsGroupsFiltering().then((response: any) => {
      this.schools = response.data.schools;
    });
  },
});
